<script setup>

import { reactive, watch } from 'vue';
import DatePicker from 'primevue/datepicker';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';

const props = defineProps({
    filter: Object,
    activeIndex: Number
});

const emit = defineEmits(['onSearch', 'clearFilter']);

const localFilter = reactive({ ...props.filter });

watch(props.filter, (newFilters) => {
    Object.assign(localFilter, newFilters);
});

const emitSearch = () => {
    emit('onSearch', localFilter);
};

</script>

<template>
    <div class="d-flex flex-wrap justify-content-center align-items-center">
        <DatePicker placeholder="Data inicio" class="m-2" v-model="filter.data_inicio" dateFormat="dd/mm/yy"  />
        <DatePicker placeholder="Data Fim" class="m-2" v-model="filter.data_fim" dateFormat="dd/mm/yy"  />
        <InputText placeholder="UUID" class="m-2" v-model="filter.uuid"/>
        <InputText placeholder="Class" class="m-2" v-model="filter.entity"/>
        <InputText v-if="activeIndex === 1" placeholder="Exception" class="m-2" v-model="filter.exception"/>

        <div>
            <Button
                raised rounded icon="pi pi-search"
                label="Pesquisar"
                title="Pesquisar"
                class="m-2"
                @click="emitSearch"
            ></Button>

            <Button
                raised rounded icon="pi pi-filter-slash"
                label="Limpar Filtro"
                title="Limpar"
                class="m-2"
                @click="$emit('clearFilter')"
            ></Button>
        </div>
    </div>
</template>
